import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ProviderModel } from 'src/app/models/archive/provider.model';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ProviderUpdateDocumentModel } from './../../../../models/archive/provider-update-document.model';
import { ProviderService } from './../../../../services/archive/provider.service';

@Component({
  selector: 'app-update-document-provider',
  templateUrl: './update-document-provider.component.html',
  styleUrls: ['./update-document-provider.component.scss'],
  standalone: false
})
export class UpdateDocumentProviderComponent implements OnInit {

  changeDocument: boolean = false;
  formProviderUpdate: FormGroup = new FormGroup({});
  providerContract: ProviderModel = new ProviderModel();
  providerId: number = 0;
  suscription: Subscription;

  constructor(public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private providerService: ProviderService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm();
  }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.providerId = inputs.providerId;
    });
    await this.getProviderById();
  }

  close() {
    const data: ModalObjectType = {};
    if (this.changeDocument) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  async getDigitVerification() {
    const document = this.formProviderUpdate.get("document")?.value;
    if (document == "") {
      this.formProviderUpdate.controls["digitVerification"].setValue(-1);
      this.toastHandlerService.showToast(
        'error',
        'El documento ingresado no es válido.'
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.providerService.getDigitVerification(document));
      this.formProviderUpdate.controls["digitVerification"].setValue(response);
    } catch (error) {
      console.error("Error al obtener el digito de verificacion.", error);
      this.formProviderUpdate.controls["digitVerification"].setValue(-1);
    }
  }

  async getProviderById() {
    try {
      this.providerContract = await firstValueFrom(this.providerService.getProviderById(this.providerId));
      this.validateForm();
    } catch (error) {
      console.error('Error al buscar proveedor por ID.', error);
    }
  }

  async send() {
    this.formProviderUpdate.enable();
    if (this.formProviderUpdate.valid) {
      const modelProvider = this.formProviderUpdate.value as ProviderUpdateDocumentModel;
      try {
        this.providerContract = await firstValueFrom(this.providerService.updateProviderDocument(modelProvider));
        this.toastHandlerService.showToast(
          'success',
          'El documento del Proveedor fue modificado exitosamente.'
        );
        this.validateForm();
        this.changeDocument = true;
        this.close();
      } catch (error) {
        console.error("Error updating client document.", error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Todos los campos marcados con (*) son obligatorios.'
      );
    }
  }

  validateForm() {
    this.formProviderUpdate = this.formBuilder.group({
      providerId: [this.providerContract.providerId, [Validators.required, Validators.min(1)]],
      document: [this.providerContract.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [this.providerContract.digitVerification, [Validators.required, Validators.min(0), Validators.max(9)]]
    });
    setTimeout(() => this.formProviderUpdate.controls["digitVerification"].disable(), 100);
  }

}
